import React from 'react'

export default function PrivacyPolicy() {
    return (
        <div className='tc_cms_pages_wrapper  py-5 animate__animated animate__fadeIn'>

            <div className="container">

                <div className='main'>
                    <h1><span>Privacy Policy</span></h1>
                    <p><strong>Navchr Online</strong></p>
                    <p>Legal/GST Name: Navchr Online</p>
                    <p>Address: Plot No 10, Baniya Ka Bagh, Jaipur Bye Pass, Alwar, Rajasthan – 301001</p>
                    <p>Effective Date: 01/01/2026</p>

                    <h3>1. Introduction</h3>
                    <p>Navchr Online ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website and use our services.</p>

                    <h3>2. Information We Collect</h3>
                    <p>We may collect the following types of information:</p>
                    <ul>
                        <li>Personal Information (Name, phone number, email address, etc.)</li>
                        <li>Payment Information (processed securely via payment gateways; we do not store card details)</li>
                        <li>Transaction details related to purchases</li>
                        <li>Device and browsing information (IP address, browser type, cookies)</li>
                    </ul>

                    <h3>3. Use of Information</h3>
                    <p>We use the collected information for:</p>
                    <ul>
                        <li>Processing payments and orders</li>
                        <li>Providing customer support</li>
                        <li>Improving our website and services</li>
                        <li>Sending order updates and important notifications</li>
                        <li>Preventing fraudulent transactions</li>
                    </ul>

                    <h3>4. Payment Security</h3>
                    <p>All payments are processed through secure and authorized payment gateways.</p>
                    <p>We do not store sensitive payment information such as card numbers, CVV, or OTP details.</p>

                    <h3>5. Sharing of Information</h3>
                    <p>We do not sell or rent your personal data.</p>
                    <p>We may share information only with:</p>
                    <ul>
                        <li>Payment gateway providers</li>
                        <li>Logistics/shipping partners</li>
                        <li>Legal authorities, if required by law</li>
                    </ul>

                    <h3>6. Cookies & Tracking</h3>
                    <p>Our website may use cookies to enhance user experience.</p>
                    <p>Users can choose to disable cookies through their browser settings.</p>

                    <h3>7. Data Security</h3>
                    <p>We implement appropriate security measures to protect your personal information from unauthorized access, misuse, or disclosure.</p>

                    <h3>8. User Rights</h3>
                    <p>Users may:</p>
                    <ul>
                        <li>Request access to their personal data</li>
                        <li>Request correction or deletion of their data</li>
                        <li>Opt out of marketing communications</li>
                    </ul>

                    <h3>9. Third-Party Links</h3>
                    <p>Our website may contain links to third-party websites. We are not responsible for their privacy practices.</p>

                    <h3>10. Policy Updates</h3>
                    <p>We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page.</p>

                    <h3>11. Contact Information</h3>
                    <p>Navchr Online</p>
                    <p>Plot No 10, Baniya Ka Bagh, Jaipur Bye Pass, Alwar, Rajasthan – 301001</p>
                    <p>Phone: <a href="tel:9336111631">9336111631</a></p>
                    <p>Email: <a href="mailto:support@navchr.com">support@navchr.com</a></p>
                </div>

            </div>
        </div>
    )
}
